var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('navigation'),_vm._v(" "),_c('banner',{attrs:{"mainzh":"集团介绍","mainen":"INTRODUCE"}}),_vm._v(" "),_c('div',{staticClass:"main-con"},[_c('vmenu'),_vm._v(" "),_c('vcontent')],1),_vm._v(" "),_c('vfooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c43e167e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Home.vue
// module id = null
// module chunks = 